"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doCapabilitiesMatch = void 0;
const doCapabilitiesMatch = (capabilities, vendorCapabilities) => {
  let result = true;
  capabilities?.forEach(x => {
    if (!vendorCapabilities?.includes(x)) {
      result = false;
    }
  });
  return result;
};
exports.doCapabilitiesMatch = doCapabilitiesMatch;